<template>
  <div class="container">
    <div class="ui left aligned grid">
      <h1>{{title}} Page</h1>
    </div>

    <div class="ui divider"></div>
    <form class="ui form grid segment" @submit.prevent="pageUpdate">
      <div class="ui grid row stackable">
        <div class="eight wide column ">
          <label>Name</label>
          <input
            type="text"
            name="Name"
            placeholder=""
            v-model="name"
            :disabled="disabled"
            class="disabled field"
          />
        </div>
        <div class="eight wide column ">
          <label>Block Name (Generated from Name)</label>
          <input type="text" name="Name" placeholder="" v-model="niceBlockId" />
        </div>
        <div class="sixteen wide column">
          <label>Content</label>
          <froala :config="config" v-model="Content" :tag="'textarea'"></froala>
        </div>
        <div class="eight wide column">
          <div class="ui buttons">
            <button class="ui positive button">{{button}} Page</button>
            <div class="or"></div>
            <div class="ui light button" @click="$router.go(-1)">Cancel</div>
          </div>
        </div>
        <div class="eight wide column" v-if="this.deleteBtn">
          <div class="ui primary button right floated" @click="deleteModal">
            Delete Block
          </div>
        </div>
      </div>
    </form>
    <semantic-modal medium flip vertical :active.sync="showModal">
      <i class="close icon"></i>
      <div class="header">
        Are you sure you want to delete this page?
      </div>
      <div class="actions">
        <div class="ui black deny button" @click="showModal = false">
          Nope
        </div>
        <div class="ui positive right labeled icon button" @click="pageDelete">
          Yes
          <i class="checkmark icon"></i>
        </div>
      </div>
    </semantic-modal>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import { config } from "@/assets/js/variables.js";

import SemanticModal from "vue-ya-semantic-modal";

export default {
  name: "EditPage",
  computed: {
    disabled() {
      if (this.$route.params.id == undefined) {
        return false;
      } else {
        return true;
      }
    },
  },
  components: {
    SemanticModal: SemanticModal(),
  },
  data() {
    return {
      showModal: false,
      deleteBtn: false,
      name: "",
      niceBlockId: "",
      Content: "",
      active: false,
      error: "",
      config: config,
      button: "",
      title: ""
    };
  },
  mounted() {
    if (this.$route.params.id == undefined) {
      this.deleteBtn = false;
      this.button = 'Add';
      this.title = 'Add';
    } else {
      this.pageDetails();
      this.deleteBtn = true;
      this.button = 'Save';
      this.title = 'Edit';
    }
  },
  methods: {
    deleteModal() {
      this.showModal = !this.showModal;
    },
    pageDetails() {
      apiService
        .getPagesDetails({ id: this.$route.params.id })
        .then((request) => {
          this.pageSuccessful(request);
        })
        .catch((err) => this.pageFailed(err));
    },
    pageSuccessful(request) {
      (this.name = request.name),
        (this.niceBlockId = request.niceBlockId),
        (this.Content = request.content),
        (this.active = request.active);
    },
    pageFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    pageUpdate() {
      if (this.$route.params.id == undefined) {
        apiService
          .createPages({
            Name: this.name,
            content: this.Content,
            Active: this.active,
            error: false,
          })
          .then((request) => {
            this.pageSuccessful(request);
            this.$router.push("/admin/pages");
          })
          .catch((err) => this.pageFailed(err));
      } else {
        // console.log(this.content);
        apiService
          .updatePages({
            id: this.$route.params.id,
            Name: this.name,
            content: this.Content,
            Active: this.active,
            error: false,
          })
          .then((request) => {
            this.pageSuccessful(request);
            this.$router.push("/admin/pages");
          })
          .catch((err) => this.pageFailed(err));
      }
    },
    pageDelete() {
      // console.log('delete');

      apiService
        .deletePages({ id: this.$route.params.id })
        .then((request) => {
          this.pageSuccessful(request);
          this.$router.push("/admin/pages");
        })
        .catch((err) => this.pageFailed(err));
    },
  },
};
</script>

<style module></style>
